import {USER_LOGIN} from './types';
import request, {decryptRandomNumber, setAuthToken, encryptPwdHash} from '../../../api/api';

export function setCurrentUser(login, pwdHash, token, remember) {
    localStorage.setItem('athen_auth', JSON.stringify({login, pwdHash, token, remember}));
    setAuthToken(token);

    return {
        type: USER_LOGIN,
        payload: {login, pwdHash, token, remember}
    }
}

export default function UserLogin(login, pwdHash, remember, onError = null) {
    return dispatch => {
        setAuthToken(null);
        return request('/v1/auth/session?login=' + encodeURIComponent(login)).then(
            data => {
                const {encryptedRandom, sessionGuid} = data.data;
                const decryptedRandom = decryptRandomNumber(pwdHash, encryptedRandom);
                const encryptedHash = encryptPwdHash(pwdHash, decryptedRandom);

                return request('/v1/auth/token?encrypted=' + encryptedHash.toString() + '&session_guid=' + sessionGuid).then(
                    data => {
                        const token = data.data.token;
                        dispatch(setCurrentUser(login, pwdHash, token, remember));
                    },
                    error => {
                        if (onError) {
                            onError();
                        }

                        return Promise.reject(error);
                    }
                );
            },
            error => {
                if (onError) {
                    onError();
                }

                return Promise.reject(error);
            }
        );
    };
};


/** WEBPACK FOOTER **
 ** ./src/modules/auth/actions/UserLogin.js
 **/